import { createAnnouncement } from "@/api/common";
import { CustomEditor } from "@/components";
import { Button } from "@/components/ui/button";
import { removeEmptyOrNull, showSuccessToast, } from "@/lib/utils";
import { ILesson } from "@/types/lesson.types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Formik } from "formik";
import * as Yup from "yup";

type Props = {
  lesson: ILesson;
  closeModal: () => void;
};

const AddAnnouncement = ({ lesson, closeModal }: Props) => {
  const queryClient = useQueryClient();

  const initialValues = {
    announcement: "",
    lesson_id: lesson?.id,
  };
  const validationSchema = Yup.object().shape({
    lesson_id: Yup.string().required("This field is required"),
    announcement: Yup.string(),
  });

  const { mutate, isLoading } = useMutation(createAnnouncement, {
    onSuccess: () => {
      showSuccessToast("Announcement created successfully");
      queryClient.refetchQueries({ queryKey: ["lesson"] });
      closeModal();
    },
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => mutate(removeEmptyOrNull(values))}
    >
      {({ handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="grid gap-4">
          <CustomEditor
            label="Announcement"
            setState={(editorState) => setFieldValue("announcement", editorState)}
          />
          <div className="flex items-center gap-3 ml-auto">
            <Button type="button" variant="outline">
              Cancel
            </Button>
            <Button
              disabled={isLoading}
              type="submit"
              className="min-w-[100px]"
            >
              Save
            </Button>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default AddAnnouncement;
